import { toOurProductsPage } from '@/feature/product/services/product.routing'
import { toProductListCategoryOrUniversePage } from '@/feature/universe/services/universe.routing'
import { isPathOrExternalUrl } from '@/lib/utils/link-utils'
import type { FooterLinkProps } from './Footer.schema'

import { Link } from '@/ui/links/link/Link.client'

export type FooterLinkSection = 'aboutUs' | 'needHelp' | 'products'

export function FooterLink({
  name,
  href,
  targetBlank,
  linkSection,
}: FooterLinkProps & { linkSection: FooterLinkSection }): React.ReactElement {
  const finalHref =
    linkSection === 'products'
      ? href === '' || href === '/'
        ? toOurProductsPage()
        : isPathOrExternalUrl(href)
          ? href
          : toProductListCategoryOrUniversePage(href)
      : href

  const action =
    linkSection === 'aboutUs'
      ? 'rubrique à propos de'
      : linkSection === 'needHelp'
        ? "rubrique besoin d'aide"
        : 'rubrique les produits'

  return (
    <Link
      variant="free"
      underlined="hover"
      className="box-border block break-inside-avoid items-center py-0.5"
      href={finalHref}
      opensInNewTab={targetBlank}
      title={name}
      trackingData={{
        event: 'gaEvent',
        eventCategory: 'footer',
        eventAction: action,
        eventLabel: name,
      }}
    >
      {name}
    </Link>
  )
}
